export default function About() {
  return (
    <div data-testid="about-page">
      <section className="container-x pt-24 pb-16">
        <div className="max-w-3xl">
          <div className="eyebrow">About</div>
          <h1 className="fade-up font-display text-5xl lg:text-6xl mt-6 tracking-tight text-[#0F172A] leading-none">
            A practice defined by
            <br /><span className="italic text-[#C2A679]">restraint.</span>
          </h1>
        </div>
      </section>

      <section className="container-x pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            <p className="text-lg text-[#1A1D20] leading-relaxed">
              EBImmigration is a boutique employment-based immigration law firm founded on a simple
              premise: the highest-scrutiny petitions deserve undivided attention. We take a limited
              number of matters each quarter so that every case receives senior-attorney drafting from
              intake through adjudication.
            </p>
            <p className="mt-6 text-lg text-[#1A1D20] leading-relaxed">
              We serve clients globally — researchers moving to U.S. universities, founders relocating
              their companies, and artists whose work has already been recognized on the national stage.
              Our engagement letters are fixed-fee. RFE responses are included. No paralegal draft ever
              leaves the office without partner review.
            </p>
            <div className="mt-14 grid grid-cols-2 gap-8">
              {[["300+", "Petitions filed"], ["94%", "EB-1A approval"], ["12", "Average business days to RFE response"], ["40+", "Client countries"]].map(([n, l]) => (
                <div key={l} className="border-t border-[#0F172A]/20 pt-6">
                  <div className="font-display text-4xl text-[#0F172A]">{n}</div>
                  <div className="mt-2 text-xs uppercase tracking-widest text-[#4A4D50]">{l}</div>
                </div>
              ))}
            </div>
          </div>
          <aside className="md:col-span-5">
            <div className="card-editorial p-10">
              <div className="eyebrow">Principal</div>
              <div className="font-display text-2xl mt-3 text-[#0F172A]">Attorney Name, Esq.</div>
              <div className="mt-2 text-sm text-[#4A4D50]">Founder · Managing Attorney</div>
              <p className="mt-6 text-[#4A4D50] leading-relaxed text-sm">
                Fifteen years of employment-based immigration practice. Prior experience at a top-tier
                AmLaw firm's business immigration group before founding EBImmigration.
              </p>
              <div className="mt-8 pt-6 border-t border-[#0F172A]/10 text-xs eyebrow text-[#4A4D50]">
                Admitted · NY · State Bar of California
              </div>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
